ServicesCtrl.$inject = ['$scope', '$state', '$stateParams', 'PortalApi', 'Notification','$translate', 'Localization'];

function ServicesCtrl($scope, $state, $stateParams, PortalApi, Notification,$translate, Localization) {

    $scope.preLoader = false;
    $scope.activeTab = 'all';
    $scope.templates = [];
    $scope.archive = [];
    $scope.id = null;
    $scope.changeTmpAmount = false;
    $scope.activeSubMenu = 'none';
    $scope.oldNameTemplate = "";
    $scope.newTempName = "";
    $scope.deleteVerification = false;
    $scope.realyDeleteTemplate = false;
    $scope.openMenu = false;
    $scope.renameTmpl = false;

    $scope.closeAll = function() {
        $scope.id = null;
        $scope.renameTmpl = false;
        $scope.changeTmpAmount = false;
        $scope.openMenu = false;
    }
    $scope.doChanges = function (obj) {
        $scope.closeAll();
        $scope.id = obj.template_id;
        $scope.renameTmpl = true;
    };
    $scope.dropdownMenuTemplate = function(id) {
        $scope.closeAll();
        if ($scope.id != id) {
            $scope.id = id;
            $scope.openMenu = true;
        } else {
            $scope.id = null;
        }
    }
    $scope.startChangeAmount = function(tmpl, data) {
        $scope.closeAll();
        if (!data) {
            $scope.id = null;
        } else {
            $scope.id = tmpl.template_id;
            $scope.changeTmpAmount = !$scope.changeTmpAmount;
        }
    }
    $scope.changeAmount = function(tmpl, newAmount) {
        $scope.closeAll();
        tmpl.amount = newAmount;
        $scope.id = null;
    }

     $scope.sendNewName = function(obj, newName){
         $scope.oldNameTemplate = obj.template_name;

         obj.template_name = newName;

        PortalApi.setTemplateNewName(obj).then(function (response) {

            Localization.notifyTemplate('success', 'NOTIFICATION.SUCCESS.TEMPLATE_SAVE', 5, true);

        },function (response) {
            obj.template_name = $scope.oldNameTemplate;

            Localization.notifyTemplate('error', 'ERRORS.TEMPLATE_SAVE', 5, true);

        });
        $scope.renameTmpl = false;
        $scope.id = null;
    };


    $scope.changeTab = function(tabName) {
        $scope.activeTab = tabName;
    };

    var toggleMenu = document.getElementsByClassName('toggleMenu');
    var icons = {};

    $scope.toggle = function(index) {

        if (toggleMenu[index].style.display === 'block') {

            toggleMenu[index].style.display = 'none';
            $scope.activeSubMenu = 'none';
        } else {
            toggleMenu[index].style.display = 'block';
            for (var i = 0; i < toggleMenu.length; i += 1) {
                if (i !== index) {
                    toggleMenu[i].style.display = 'none';
                }
            }

        }
    };

    $scope.getServiceIcon = function(serviceId) {
        return icons[serviceId] || '';
    };

    $scope.changeArchive = function(template, archive) {
        $scope.preLoader = true;
        template.archive = archive;
        $scope.id = null;
        $scope.changeTmpAmount = false;
        $scope.openMenu = false;

        PortalApi.updateStatus(template).then(function(response) {
            getTemplates();
        }, function () {
            $scope.preLoader = false;
        });
    };

    $scope.toService = function(template) {

        $scope.preLoader = true;
        $state.go('pages.payment', {
            amount: template.amount,
            serviceId: template.service_id,
            url: template.service_id,
            fields: template.fields,
            autoCheck: true,
            templateId: true,
            destination: template.destination
        });
    };

    $scope.deleteTemplate = function(id, verif) {
    $scope.tamplateID = id;
    $scope.deleteVerification = true;
      if (verif == false) {
        $scope.deleteVerification = false;
      }
      if ($scope.deleteVerification && verif) {
        PortalApi.removeTemplate(id).then(function(response) {
          if (response.data.status == "ok") {
            for (var i = 0; i < $scope.templates.length; i++) {
              if ($scope.templates[i].template_id == id) {
                  $scope.templates.splice(i, 1);
                  break;
              }
            }
            for (var i = 0; i < $scope.archive.length; i++) {
              if ($scope.archive[i].template_id == id) {
                  $scope.archive.splice(i, 1);
                  break;
              }
            }
          } else {
              Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 5, true);
          }
          $scope.deleteVerification = false;
        });
      }
    }

    function getTemplates() {
        var ids = [];
        $scope.templates = [];
        $scope.archive = [];
        $scope.preLoader = true;

        PortalApi.getTemplates()
            .then(function(response) {

                response = response.plain();

                if (response.length) {
                    response.forEach(function(template) {
                        var tmpValue = {};
                        if (typeof(template.fields) == "object" && Object.keys(template.fields).length) {
                            for (var key in template.fields) {
                              if (template.fields[key].restriction !== 'INV' && template.fields[key].type != 'PERIOD') {
                                tmpValue = template.fields[key];
                              }
                            };

                            template.fieldValue = tmpValue ? tmpValue.value : '';
                            template.fieldValueName = tmpValue ? tmpValue.heading : '';

                            if(template.show_field_sys_name){
                                var tmpValue2 = tmpValue[template.show_field_sys_name];
                                var tmpValue2Name = tmpValue[template.show_field_sys_name].heading;
                                if(tmpValue2) {
                                    template.fieldValue = tmpValue2;
                                }
                                if (tmpValue2Name) {
                                    template.fieldValueName = tmpValue2Name;
                                }
                            }

                        }

                        if (!template.archive) {

                            $scope.templates.push(template);
                        } else {
                            $scope.archive.push(template);
                        }

                        if (ids.indexOf(template.service_id) === -1) {
                            ids.push(template.service_id);
                        }
                    });
                }

                PortalApi.searchServices({
                    query: ids.join(' ')
                }).then(function (services) {
                    services.forEach(function(service) {
                        icons[service.id] = service.icon;
                    });
                }).finally(function () {
                    $scope.preLoader = false;
                })

            }, function(reason) {
                $scope.preLoader = false;

                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.TEMPLATES_CANT_GET', 5, true);
            });
    }

    getTemplates();

}

module.exports = ServicesCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/templates/controllers/templates.js
 ** module id = 296
 ** module chunks = 1
 **/